export const validIntlDate = '1524734553027'

export enum Language {
  DOT_NET = '.NET',
  NODE = 'Node',
  PYTHON = 'Python',
  RUBY = 'Ruby',
  JAVA = 'Java'
}
